<template>
  <div class="map-style point">
    <div class="map-style__block">
      <point-icon-picker
        :id="id"
        :layer-style="layerStyle"
        :layer-controller="layerController"
      />
    </div>
    <div class="map-style__block" v-if="!layerStyle.icon.enabled">
      <classes-color-picker
        @change-property="changeProperty"
        @change-classes="changeClasses"
        @change-strings="changeStrings"
        :id="id"
        :layer-style="layerStyle.style"
        :layer-controller="layerController"
        property="circle"
        title="Цвет"
      />
    </div>
    <div class="map-style__block" v-if="!layerStyle.icon.enabled">
      <classes-slider-picker
        @change-property="changeProperty"
        @change-range="changeRange"
        :id="id"
        :layer-style="layerStyle.style"
        :layer-controller="layerController"
        property="circle-radius"
        title="Радиус"
      />
    </div>
    <div class="map-style__block" v-if="!layerStyle.icon.enabled">
      <point-outline-picker
        @change-property="changeProperty"
        :id="id"
        :layer-style="layerStyle.style"
        :layer-controller="layerController"
        property="circle"
        title="Обводка"
      />
    </div>
    <div class="map-style-block">
      <popup-fields-picker
        :id="id"
        :layer-style="layerStyle"
        :layer-controller="layerController"
        title="Информация"
      />
    </div>
  </div>
</template>

<script>
import PointIconPicker from "../input-sources/point-icon-picker";
import ClassesColorPicker from "../input-sources/classes-color-picker";
import ClassesSliderPicker from "../input-sources/classes-slider-picker";
import PointOutlinePicker from "../input-sources/point-outline-picker";
import PopupFieldsPicker from "../input-sources/popup-fields-picker";

export default {
  props: ["id", "layer-style", "layer-controller"],
  components: {
    PointIconPicker,
    ClassesColorPicker,
    ClassesSliderPicker,
    PointOutlinePicker,
    PopupFieldsPicker
  },
  methods: {
    changeProperty(payload) {
      this.$emit("change-property", payload);
    },
    changeClasses(payload) {
      this.$emit("change-classes", payload);
    },
    changeStrings(payload) {
      this.$emit("change-strings", payload);
    },
    changeRange(payload) {
      this.$emit("change-range", payload);
    }
  },
  created() {
    if (!this.layerStyle.icon) {
      this.$set(this.layerStyle, "icon", {
        enabled: false,
        name: "1.5_Russian_road_sign.svg",
        size: 16
      });
    }
  }
};
</script>

<style lang="scss">
.map.style-picker {
  &__title {
    vertical-align: middle;
    font-weight: bold;

    &:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      width: 4px;
      height: 18px;
      border-radius: 2px;
      background-color: var(--accent_primary) !important;
      margin-right: 8px;
      margin-top: -1px;
    }
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-bottom: 5px;
    line-height: 24px;

    i {
      font-size: 14px;
    }
  }
}
.simple-settings-block {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-bottom: 5px;
    line-height: 24px;

    i {
      font-size: 14px;
    }
  }

  &__container {
    padding-left: 15px;

    .el-icon-loading {
      margin-right: 8px;
    }
  }
}
</style>
